<div class="w-100 d-flex justify-content-center mb-2">
    <div class="d-flex justify-content-center mb-2 mt-2" style="width: 240px !important">
        <div class="w-100 avs-route-station-settings-dropdown-container justify-content-between">
            <span class="ms-1 fw-semibold text-secondary">Verkehrsstufe</span>
            <div [ngClass]="isTrafficDropdownOpen ? 'border-danger' : ''" class="border d-flex justify-content-between"
                role="button" (click)="onTrafficDropdownClicked()">
                <div class="ms-2 p-1">{{ selectedTraffic.name }}</div>
                <img *ngIf="!isTrafficDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                    alt="caret-down open select">
                <img *ngIf="isTrafficDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                    alt="caret-up close select">
            </div>
            <avs-dropdown [selectInput]="trafficSelect" [activeItem]="selectedTraffic"
                (onItemClicked)="onTrafficItemClicked($event)" [isHeaderActive]="false" *ngIf="isTrafficDropdownOpen"
                class="avs-route-station-settings-dropdown-container">
            </avs-dropdown>
        </div>
    </div>
</div>

<div class="w-100 d-flex justify-content-center mb-2">
    <div class="d-flex justify-content-center mb-2 mt-2" style="width: 240px !important">
        <div class="w-100 avs-route-station-settings-dropdown-container justify-content-between">
            <span class="ms-1 fw-semibold text-secondary">Verkehrssituation</span>
            <div [ngClass]="isVerkehrszustandDropdownOpen ? 'border-danger' : ''"
                class="border d-flex justify-content-between" role="button"
                (click)="onVerkehrszustandDropdownClicked()">
                <div class="ms-2 p-1">{{ selectedVerkehrszustand.name }}</div>
                <img *ngIf="!isVerkehrszustandDropdownOpen" class="me-2" src="assets/icons/caret-down.svg"
                    alt="caret-down open select">
                <img *ngIf="isVerkehrszustandDropdownOpen" class="me-2" src="assets/icons/caret-up.svg"
                    alt="caret-up close select">
            </div>
            <avs-dropdown [selectInput]="verkehrszustandSelect" [activeItem]="selectedVerkehrszustand"
                (onItemClicked)="onVerkehrszustandItemClicked($event)" [isHeaderActive]="false"
                *ngIf="isVerkehrszustandDropdownOpen" class="avs-route-station-settings-dropdown-container">
            </avs-dropdown>
        </div>
    </div>
</div>

<div class="w-100 d-flex justify-content-center mb-2">
    <button [disabled]="selectedMqChannel  === undefined || selectedVerkehrszustand.name === 'Verkehrssituation'"
        class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2" type="button" (click)="createMqControl()"> Manuelle
        Steuerung erstellen</button>
    <button [disabled]="selectedMqChannel === undefined" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="setMqManualControlOff()">
        Manuelle
        Steuerung entfernen</button>

</div>